import { render } from "./ButtonTab.vue?vue&type=template&id=2c3602ac&scoped=true&ts=true"
import script from "./ButtonTab.vue?vue&type=script&lang=ts"
export * from "./ButtonTab.vue?vue&type=script&lang=ts"

import "./ButtonTab.vue?vue&type=style&index=0&id=2c3602ac&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3602ac"]])

export default __exports__